<template>
  <at-modal :model-value="modelValue" size="3xl" @update:model-value="$emit('update:model-value', false)">
    <div class="-mx-6 -mt-4 -mb-6 overflow-hidden">
      <div class="text-center px-2 py-2">
        <div class="px-4 py-2">
          <h1 class="font-bold text-2xl text-gray-900 dark:text-white">
            {{ $t('entities.clientPassport.clientExistsModal.title') }}
          </h1>
          <p class="mt-1 text-sm text-gray-500 dark:text-gray-300">
            {{ $t('entities.clientPassport.clientExistsModal.subTitle') }}
          </p>
        </div>
      </div>

      <div
        class="mt-6 grid justify-items-stretch gap-x-3 gap-y-4 px-10"
        :style="{
          gridTemplateColumns: '1fr minmax(30px, 56px) 1fr minmax(30px, 56px) 1fr',
          gridTemplateRows: '1fr auto',
        }"
      >
        <a href="https://alifnasiya.uz/ru" class="block">
          <img :src="step1" alt="step 1 image" class="w-full h-full" />
        </a>

        <img :src="arrow" alt="arrow image" class="self-center" />

        <img :src="step2" alt="step 2 image" />

        <img :src="arrow" alt="arrow image" class="self-center" />

        <img :src="step3" alt="step 3 image" />

        <div class="flex items-start gap-2">
          <div
            class="w-[26px] h-[26px] shrink-0 bg-blue-600 text-white flex items-center justify-center rounded-sm text-base font-medium"
          >
            1
          </div>
          <p class="font-medium text-black dark:text-white text-xs">
            {{ $t('entities.clientPassport.clientExistsModal.steps[0]') }}
          </p>
        </div>

        <div></div>

        <div class="flex items-start gap-2">
          <div
            class="w-[26px] h-[26px] shrink-0 bg-blue-600 text-white flex items-center justify-center rounded-sm text-base font-medium"
          >
            2
          </div>
          <p class="font-medium text-black dark:text-white text-xs">
            {{ $t('entities.clientPassport.clientExistsModal.steps[1]') }}
          </p>
        </div>

        <div></div>

        <div class="flex items-start gap-2">
          <div
            class="w-[26px] h-[26px] shrink-0 bg-blue-600 text-white flex items-center justify-center rounded-sm text-base font-medium"
          >
            3
          </div>
          <p class="font-medium text-black dark:text-white text-xs">
            {{ $t('entities.clientPassport.clientExistsModal.steps[2]') }}
          </p>
        </div>
      </div>

      <div class="mt-8 grid grid-cols-2 px-6 py-3 bg-gray-100 dark:bg-gray-700">
        <p class="text-center font-medium text-gray-900 dark:text-white">
          {{ $t('entities.clientPassport.clientExistsModal.footer') }}
        </p>
        <at-button type="button" color="primary" @click="$emit('update:model-value', false)">
          {{ $t('entities.clientPassport.clientExistsModal.ok') }}
        </at-button>
      </div>
    </div>
  </at-modal>
</template>

<script setup>
  import { AtModal, AtButton } from '@packages/aliftech-ui';

  import step1 from '../images/step_1.png';
  import step2 from '../images/step_2.png';
  import step3 from '../images/step_3.png';
  import arrow from '../images/arrow.svg';

  defineProps({
    modelValue: {
      type: Boolean,
      required: true,
    },
  });

  defineEmits(['update:model-value']);
</script>
